import { Inject } from '../';
import { Constants, Order } from '../../Contract';
var SwitchIdWorker = (function () {
    function SwitchIdWorker(inject) {
        if (inject === void 0) { inject = null; }
        this.inject = inject;
        this.inject = inject || Inject.Instance;
        this.modelResolver = this.inject.resolve(Constants.ModelResolver);
    }
    SwitchIdWorker.prototype.process = function (response) {
        if (response.switchIds) {
            this.modelResolver.switchIds(response.switchIds);
        }
    };
    Object.defineProperty(SwitchIdWorker.prototype, "Order", {
        get: function () {
            return Order.ORD;
        },
        enumerable: false,
        configurable: true
    });
    return SwitchIdWorker;
}());
export { SwitchIdWorker };
